import { Button } from "@/components/ui/button";

import { TableCell, TableRow } from "@/components/ui/table";
import { type Guest } from "@/hooks/useGuests";
import { Edit, Trash2 } from "lucide-react";

interface GuestRowProps {
  guest: Guest;
  canEdit?: boolean;
  canDelete?: boolean;
  onEdit: (guest: Guest) => void;
  onDelete: (guest: Guest) => void;
}

const GuestRow = ({
  guest,
  canEdit,
  canDelete,
  onEdit,
  onDelete,
}: GuestRowProps) => (
  <TableRow>
    <TableCell>{guest.name}</TableCell>

    <TableCell> {guest.email || "-"}</TableCell>

    <TableCell>{guest.phone || "-"}</TableCell>

    <TableCell>{guest.origins?.name || "-"}</TableCell>

    {(canEdit || canDelete) && (
      <TableCell className="flex items-center space-x-2">
        {canEdit && (
          <Button variant="outline" size="sm" onClick={() => onEdit(guest)}>
            <Edit className="h-4 w-4" />
          </Button>
        )}

        {canDelete && (
          <Button
            variant="destructive"
            size="sm"
            onClick={() => onDelete(guest)}
          >
            <Trash2 className="h-4 w-4" />
          </Button>
        )}
      </TableCell>
    )}
  </TableRow>
);

export default GuestRow;
